import { render } from "./GalleryArrowButtons.vue?vue&type=template&id=ba233238&scoped=true"
import script from "./GalleryArrowButtons.vue?vue&type=script&lang=js"
export * from "./GalleryArrowButtons.vue?vue&type=script&lang=js"

import "./GalleryArrowButtons.vue?vue&type=style&index=0&id=ba233238&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba233238"],['__file',"src/scripts/sections/modules/gallery/GalleryArrowButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba233238"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba233238', __exports__)) {
    api.reload('ba233238', __exports__)
  }
  
  module.hot.accept("./GalleryArrowButtons.vue?vue&type=template&id=ba233238&scoped=true", () => {
    api.rerender('ba233238', render)
  })

}


export default __exports__